import Slice9Panel from "../../../../../shared/lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import RichTextStyling from "../../../../../shared/src/ranj/app/ui/richtext/RichTextStyling";
import RichTextWrapper from "../../../../../shared/src/ranj/app/ui/richtext/RichTextWrapper";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import ExampleItemView from "./ExampleItemView";
import SpotView from "./SpotView";

export default class LocationView extends AbstractView {

    constructor(target) {
        super(target);

        this._initFeedbackBalloon();
        this._sampleView = new ExampleItemView(this._target.textBalloon.fish);

        this._spots = [];
        this._spotsById = {};

        for (let i = 1; i < 99; i++) {
            let spotId = `spot${i}`;
            const spotMC = target[spotId];
            if (!spotMC) {
                break;
            }
            const spot = new SpotView(i, spotMC);

            this._spots.push(spot);
            this._spotsById[spotId] = spot;
        }

        this.setRule("");

        this._balloonPanelWidth = 0;
    }

    get spots() {
        return this._spots;
    }

    /**
     * @param {number} id
     * @returns {SpotView}
     **/
    getSpotById(id) {
        return this._spotsById[id];
    }

    get target() {
        return this._target;
    }

    destroy() {
        this._spots.forEach(spot => { spot.destroy(); });
        this._spots = null;
        this._spotsById = {};
    }

    showSolutionInfo(correctInput = null) {
        this._spots.forEach((spot, idx) => {
            let str = null;
            if (correctInput) {
                const spotIdx = idx + 1;
                const solutionIdx = correctInput?.indexOf(spotIdx);
                str = `#${spotIdx}`;
                if (solutionIdx > -1) {
                    str += `\n\n${solutionIdx + 1}`;
                } 
            }
            spot.setDebugInfo(str);
        });
    }

    setSample(skin) {
        this._sampleView.show(true);
        this._sampleView.content = skin;
    }

    _initFeedbackBalloon() {
        const balloon = this._target.textBalloon;
        const balloonBg = balloon.slicedPanel.children.find(c => c instanceof createjs.Bitmap);
        this._balloonPanelBgBounds = balloonBg.getBounds();
        balloonBg.visible = false; // hide the bitmap, we'll draw our own rectangle behind it as 9 slicing caused transparency lines.

        balloon.slicedPanel.ruleLabelTextField.text = "";
        balloon.slicedPanel.shortRuleLabelTextField.text = "";
        this._ruleText = new RichTextWrapper(balloon.slicedPanel.ruleLabelTextField, RichTextStyling.DEFAULT);
        this._ruleTextShort = new RichTextWrapper(balloon.slicedPanel.shortRuleLabelTextField, RichTextStyling.DEFAULT);
    }

    /**
     * @param {string} text 
     * @param {boolean} isCorrect 
     */
    showFeedback(text, isCorrect) {
        this.setRule(text, false, isCorrect ? "correct" : "incorrect");
    }

    setRule(rule, useShortVariant = false, state = "normal") {
        const balloon = this._target.textBalloon;
        balloon.gotoAndStop(state);
        this._ruleText.text = "";
        this._ruleTextShort.text = "";
        if (useShortVariant) {
            this._ruleTextShort.text = rule;
            this._updateBalloonPanel(true); // true, as a target fish will most likely be shown
        } else {
            this._ruleText.text = rule;
            this._updateBalloonPanel(false);
        }

        //Appear/disappear balloon?
        if (!this._rule && rule) {
            createjs.Tween.get(balloon).to({ alpha: 1 }, 300, createjs.Ease.quadIn);
        } else if (!rule) {
            createjs.Tween.get(balloon).to({ alpha: 0 }, 300, createjs.Ease.quadOut);
        }

        let profState = state;
        if (state == "normal") {
            profState = rule == null ? "neutral" : "open";
        }
        this._target.professor.gotoAndStop(profState);

        this._rule = rule;
    }

    _updateBalloonPanel(clampHeightToBitmapHeight = false) {
        const padding = 30;

        const slicedPanel = this._target.textBalloon.slicedPanel;
        const panelContentBounds = slicedPanel.getBounds();
        let bgShape = slicedPanel.bgShape;
        if (bgShape) {
            slicedPanel.removeChild(bgShape);
        }

        if (!panelContentBounds) {
            return;
        }

        // Clamp panel height to height defined by bitmap in the FLA. E.g. handy for if you want the target fish to fit, but the text is smaller.
        let targetHeight = panelContentBounds.height + padding * 2;
        if (clampHeightToBitmapHeight && targetHeight < this._balloonPanelBgBounds.height) {
            targetHeight = this._balloonPanelBgBounds.height;
        }

        bgShape = new createjs.Shape();
        bgShape.graphics.beginFill('#F6F7FA').drawRect(this._balloonPanelBgBounds.x - this._balloonPanelBgBounds.width * .5, this._balloonPanelBgBounds.y - this._balloonPanelBgBounds.height * .5, this._balloonPanelBgBounds.width, targetHeight);

        slicedPanel.addChildAt(bgShape, 0);
        slicedPanel.bgShape = bgShape;
    }
}